export default __webpack_public_path__ + "static/media/regulatory--no-left-turn--g4.f2416352.png";